import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';

export const UserDelete = createAction('[UserDelete] Delete', props<{ workspaceId: string; userId: string }>());
export const UserDeleted = createAction('[UserDelete] Deleted', props<{ userId: string }>());
export const UserDeleteError = createAction('[UserDelete] Delete Error', props<{ userId: string }>());

export const initialState: Record<string, CommonApiState<undefined>> = {};

export const userDeleteFeature = createFeature({
  name: 'userDelete',
  reducer: createReducer(
    initialState,
    on(UserDelete, (state, action) => ({
      ...state,
      [action.userId]: {
        ...(state[action.userId] ?? {}),
        currentPedingApis: (state[action.userId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(UserDeleted, (state, action) => {
      return {
        ...state,
        [action.userId]: {
          ...(state[action.userId] ?? {}),
          currentPedingApis: 0,
          isError: false
        }
      };
    }),
    on(UserDeleteError, (state, action) => {
      return {
        ...state,
        [action.userId]: {
          ...(state[action.userId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectUserDeleteState }) => {
    const userDeleteIsBeingDeleted = (userId: string) =>
      createSelector(selectUserDeleteState, userDeleteState => (userDeleteState[userId]?.currentPedingApis ?? 0) > 0);

    const userDeletesAreBeingDeleted = createSelector(selectUserDeleteState, userDeleteState => {
      return Object.entries(userDeleteState).reduce((curr, [userId, value]) => {
        return { ...curr, [userId]: value.currentPedingApis > 0 };
      }, {});
    });

    const userDeleteHasPendingRequest = (userId: string) =>
      createSelector(selectUserDeleteState, userDeleteState => (userDeleteState[userId]?.currentPedingApis ?? 0) >= 2);

    return {
      userDeleteIsBeingDeleted,
      userDeleteHasPendingRequest,
      userDeletesAreBeingDeleted
    };
  }
});
